import { NotificationsOptions } from 'owa-notifications-option';
import AppNotificationsOption from 'owa-app-notifications-option/lib/AppNotificationsOption';
var notificationsSubCategory = {
    key: 'notifications',
    titleStringKey: 'optionSubcategory_notifications',
    options: [AppNotificationsOption, NotificationsOptions],
};
export default notificationsSubCategory;
//# sourceMappingURL=notificationsSubCategory.js.map